export const ANIMAL_EVENT_LIST_VIEW = "/animal-events"
export const NEW_ANIMAL_EVENT_VIEW = ANIMAL_EVENT_LIST_VIEW + "/new"
